<ng-container *ngIf="!errorGettingSettings; else settingsError">
  <ng-container *ngIf="notificationSections; else loading">
    <div class="notifications-container">
      <div class="products" [ngClass]="{ 'bulk-update': bulk, 'account-page': !bulk }">
        <ng-container *ngFor="let product of notificationSections">
          <div
            class="product"
            [ngClass]="{
              selected: selectedNotification.productId === product.productId
            }"
            (click)="selectNotification(product)"
          >
            <div class="icon" *ngIf="product.iconUrl">
              <img [src]="product.iconUrl" />
            </div>
            <div class="icon" *ngIf="product.iconType">
              <mat-icon>{{ product.iconType }}</mat-icon>
            </div>
            <div class="name">
              {{ product.name }}
            </div>
          </div>
        </ng-container>
      </div>
      <div class="notifications" [ngClass]="{ 'bulk-update': bulk, 'account-page': !bulk }">
        <div class="options">
          <app-legacy-notification-settings
            [notifications]="notificationSections"
            [product]="selectedNotification"
            [accountGroupId]="accountGroupId"
            [partnerId]="partnerId"
            [marketId]="marketId"
            [userId]="userId"
            [bulk]="bulk"
            [disabledSections]="disabledSections"
            (changes)="selectionUpdated($event)"
          ></app-legacy-notification-settings>
        </div>
      </div>
    </div>
    <div class="ns-mobile-container">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let product of notificationSections">
          <mat-expansion-panel-header
            [ngClass]="{ selected: selectedNotification.productId === product.productId }"
            (click)="selectNotification(product)"
          >
            <mat-panel-title>
              <div class="icon" *ngIf="product.iconUrl">
                <img [src]="product.iconUrl" />
              </div>
              <div class="icon" *ngIf="product.iconType">
                <mat-icon>{{ product.iconType }}</mat-icon>
              </div>
              <div class="name">
                {{ product.name }}
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-legacy-notification-settings
            [notifications]="notificationSections"
            [product]="selectedNotification"
            [accountGroupId]="accountGroupId"
            [partnerId]="partnerId"
            [marketId]="marketId"
            [userId]="userId"
            [bulk]="bulk"
            [disabledSections]="disabledSections"
            (changes)="changes.emit($event)"
          ></app-legacy-notification-settings>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </ng-container>
</ng-container>
<ng-template #loading>
  <div class="loading">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>
</ng-template>
<ng-template #settingsError>
  <div class="error-container">
    <div class="icon">
      <mat-icon>error</mat-icon>
    </div>
    <div class="message">
      {{ errorMessage | translate }}
    </div>
  </div>
</ng-template>
